export default __webpack_public_path__ + "07ad6376175c1a970a97d4c4ce28528e.png";